import React from 'react';
import { Component } from 'react';
import CarSelection from '../contents/carselection/CarSelection.js';
import { InitialState } from '../data/initialState';
import { connect } from 'react-redux';
import Header from './Header';
import Constants from '../data/constants';
import { linkPlaceholder } from '../utils/TranslationUtils';

class CarSelectionContain extends Component {
    constructor(props) {
        super(props);
        this.setModel(Constants().MODEL_S);
    }

    setModel(val) {
        this._model = val;
    }

    getModel(val) {
        return this._model;
    }

    handleSubmit(e) {
        let { handleSubmit, handleSelection } = this.props;
        handleSelection(this.getModel());
        handleSubmit(e);
    }

    render() {
        let { containerClass } = this.props;
        const carSelection = (typeof window.tesla !== "undefined") ? window.tesla.App.strings['Test_Drive/All'].content.carSelection : {};

        return (
            <div className={'content-container car-container ' + containerClass}>
                <Header 
                    title={carSelection.title}
                    title2={linkPlaceholder(
                        carSelection.title2,
                        { LEARN_MORE: carSelection.title2Lbl },
                        '/support/test-drive'
                    )}
                    title3={""} />
                <CarSelection setModel={this.setModel.bind(this)} />
                <div className='btn-container'>
                    <button className="tds-btn tds-btn--blue" data-section="carSection" onClick={this.handleSubmit.bind(this)} id="edit-submit-td-ajax-2">{carSelection.next}</button>
                </div>
            </div>
        );
    }
}

CarSelectionContain.defaultProps = InitialState().carSection

// Map Redux state to component props
function mapStateToProps(state) {
    var _state = state;

    return {
        containerClass: _state.carSection.containerClass,
    }
}

const CarSelectionContainer = connect(
    mapStateToProps
)(CarSelectionContain)

export default CarSelectionContainer


